import React, { useEffect, useRef } from "react"

const HtmlContent = ({ html }) => {
  const ref = useRef(null)

  useEffect(() => {
    if (!ref.current) return

    const scripts = ref.current.querySelectorAll("script")

    scripts.forEach(oldScript => {
      const newScript = document.createElement("script")

      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value)
      })

      newScript.appendChild(document.createTextNode(oldScript.innerHTML))

      oldScript.parentNode.replaceChild(newScript, oldScript)
    })
  }, [html])

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />
}

export default HtmlContent
